<div class="vtr-widget-device">
	<div class="container-fluid my-dev-pad">
		<div class="d-flex device-status">
				<div class="col device-info">
						<div class="family"
							id="myDevice-machine-info"
							attr.aria-label="myDevice-machine-info"
							role="text">{{myDevice.family}}</div>
							<div class="col-12 px-0 {{'dirClass' | translate}}">
									<span class="sub-header-separator">
										<fa-icon [icon]="['fas', 'minus']"
										role="img"
										attr.aria-label="minus-{{'device.myDevice.serial' | translate}}"
										transform="up-4">
										</fa-icon>
									</span>
									<span class="device-sub-header"
										id="myDevice-serial"
										attr.aria-label="myDevice-serial"><span class="{{'dirClass' | translate}}" role="text"
											[dir]="'dir' | translate">{{'device.myDevice.serial' | translate}}</span>:
										<span id="myDevice-serial-value"
											role="text">{{myDevice.sn}}
										</span>
									</span>
								</div>
								<div class="col-12 px-0">
									<span class="sub-header-separator">
										<fa-icon [icon]="['fas', 'minus']"
											role="img"
											attr.aria-label="minus-{{'device.myDevice.productNumber' | translate}}"
											transform="up-4">
										</fa-icon>
									</span>
									<span class="device-sub-header"
										id="myDevice-product-number"
										attr.aria-label="myDevice-product-number"><span class="{{'dirClass' | translate}}" role="text"
										[dir]="'dir' | translate">{{'device.myDevice.productNumber' | translate}}</span>:
											<span id="myDevice-product-number-value"
												role="text">{{myDevice.productNo}}</span>
									</span>
								</div>
								<div class="col-12 px-0">
									<span class="sub-header-separator">
										<fa-icon [icon]="['fas', 'minus']"
											role="img"
											attr.aria-label="minus-{{'device.myDevice.biosVersion'|translate}}"
											transform="up-4">
										</fa-icon>
									</span>
									<span
										id="myDevice-bios-version"
										attr.aria-label="myDevice-bios-version"
										class="{{'dirClass' | translate}} device-sub-header text-wrap"
										[dir]="'dir' | translate" role="text">{{'device.myDevice.biosVersion'|translate}}</span>
									<span class="device-sub-header text-wrap" role="text">: {{myDevice.bios}}</span>

								</div>
					</div>
					<div class="col device-image">
						<div class="circleimage">
							<img class=""
								[src]=" 'assets/icons/logo-lenovo-red.svg' | svgInline | async"
								alt="Lenovo logo">
						</div>
					</div>
		</div>

		<div class="row">
			<div class="col">
				<div class="subheader"
					role="heading"
					id="myDevice-status-title"
					attr.aria-label="myDevice-status-title"
					[dir]="'dir' | translate">{{'device.myDevice.subtitle'|translate}}</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<ul class="status-list">
					<li *ngFor="let item of deviceStatus; let i=index"
						[ngClass]="[!item.status?'good':'bad']"
						[hidden]="item.isHidden"
						tabindex="-1">
						<div class="container-fluid">
							<div class="d-flex align-items-center {{'dirClass' | translate}}">
									<div class="status-icon">
										<div class="icon-bkg">
											<fa-icon role="img"
												id="myDevice-system-details-{{item.id}}-status"
												[attr.aria-label]="'myDevice-system-details-'+item.title
											+'-status-'+(!item.status?'check':'times')"
												[icon]="['fas', !item.status?'check':'times']">
											</fa-icon>
										</div>
									</div>
								<div class="d-flex status-content justify-content-between">
									<div class="title"
										[ngClass]="[!item.status?'good':'bad']"
										id="myDevice-system-details-{{item.id}}"
										attr.aria-label="myDevice-system-details-{{item.title}}-{{item.systemDetails}}"
										[dir]="'dir' | translate">
										{{item.title}}
										<span *ngIf="item.systemDetails"
											class='systemDetails'
											[dir]="'dir' | translate">({{item.systemDetails}})</span>
									</div>
									<div *ngIf="item.status === 4"
										class="spinner-content">
										<div class="spinner-border text-secondary progress-spinner"
											role="status"></div>
									</div>

									<!--Open vantage subapges if isSystemLink===undefined or  isSystemLink  === false then user routerLink to naviagate within Lenovo Vantage Application -->
									<a routerLink="/{{item.path}}"
										id="myDevice-status-learn-more-{{item.id}}"
										title="{{item.detail}}"
										*ngIf="item.isSystemLink===undefined || (item.isSystemLink!==undefined && item.isSystemLink===false && item.status !== 4)"
										role="link"
										attr.aria-label="{{item.detail}}"
										tabindex="{{linkTabIndex}}">
										<p class="detail"
											[ngClass]="{'highlight':item.asLink}">
											<span class="{{'dirClass' | translate}}"
											[dir]="'dir' | translate">{{item.detail}}&nbsp;
												<fa-icon [icon]="['fal', 'chevron-right']"
													role="img"
													attr.aria-label="arrow-right-{{item.detail}}">
											</fa-icon></span>
										</p>
									</a>
									<!--Open Windows Settings /subapges if isSystemLink is not undefined or  then sanitise URL of windows settings page like (ms-settings:storagesense) , link href instead of routerlink value is set to URL-->
									<a *ngIf="item.isSystemLink!==undefined &&  item.isSystemLink===true && item.status !== 4"
										href="javascript:void(0);"
										id="myDevice-status-learn-more-{{item.id}}"
										role="link"
										attr.aria-label="{{item.detail}}"
										title="{{item.detail}}"
										(click)="deviceService.launchUri(item.path)"
										tabindex="{{linkTabIndex}}">
										<p class="detail"
											[ngClass]="{'highlight':item.asLink}">
											<span class="{{'dirClass' | translate}}"
											[dir]="'dir' | translate">{{item.detail}}&nbsp;
												<fa-icon [icon]="['fal', 'chevron-right']"
												role="img"
												attr.aria-label="arrow-right-{{item.detail}}">
												</fa-icon>
											</span>
										</p>
									</a>
									<!-- <div class="arrow">
										<fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
									</div> -->
								</div>
								<!-- <div class="col-auto">
								</div> -->
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
